import PaginaNaoEncontrada from './componentes/PaginaNaoEncontrada.vue';

export default {
  path: '*',
  component: PaginaNaoEncontrada
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/404/rotas.js